import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpComponent } from './help.component';
import { MyDirectivesModule } from '../../pipes/MyDirectives.module';

@NgModule({
  imports: [CommonModule, MyDirectivesModule],
  declarations: [HelpComponent],
  exports: [HelpComponent],
})
export class HelpModule {}
